import React from "react";
import "./Select.scss";
import Select from "react-select";

const customStyles = {
  option: (provided, state) => ({
    // ...provided,
    borderBottom: "1px solid #F4F4F4",
    color: state.isSelected ? "white" : state.isFocused ? "black" : "black",
    padding: 20,
    borderRadius: 0,
    border: 0,
    fontSize: ".7em",
    textTransform: "uppercase",
    fontWeight: 600,
    background: state.isSelected
      ? "#0B0B0B"
      : state.isFocused
      ? "#EFEFEF"
      : "white"
  }),
  indicatorsContainer: provided => ({
    border: 0,
    margin: 0,
    padding: 0
  }),
  singleValue: provided => ({
    border: 0,
    margin: 0,
    font: "inherit",
    fontSize: ".9em",
    padding: 0,
    borderRadius: 0
  }),
  placeholder: provided => ({
    border: 0,
    margin: 0,
    font: "inherit",
    fontSize: ".9em",
    padding: 0,
    borderRadius: 0,
    opacity: ".65"
  }),
  input: provided => ({
    border: 0,
    margin: 0,
    font: "inherit",
    fontSize: ".9em",
    padding: 0,
    borderRadius: 0
  }),
  menuList: provided => ({
    margin: 0,
    borderRadius: 0,
    maxHeight: 234,
    overflow: "auto",
    padding: 0
  }),
  control: provided => ({
    // ...provided,
    // background: "green",
    display: "flex",
    borderRadius: 0,
    border: 0,
    borderBottom: "1px solid #F4F4F4"
  }),
  valueContainer: provided => ({
    ...provided,
    padding: 0,
    border: 0,
    borderRadius: 0
  }),
  container: provided => ({
    ...provided,
    font: "inherit",
    borderRadius: 0
  }),
  noOptionsMessage: provided => ({
    ...provided,
    padding: 20,
    borderRadius: 0,
    fontSize: ".7em",
    textTransform: "uppercase",
    fontWeight: 600
  }),
  menu: provided => ({
    ...provided,
    borderRadius: 0,
    border: 0
  })
};

const S = ({ label, name, required, value, onChange, options }) => (
  <div className="Select">
    <label htmlFor={name}>{label}</label>
    <Select
      inputId={name}
      onChange={e => {
        onChange(name, e);
      }}
      value={value}
      name={name}
      required={required}
      styles={customStyles}
      options={options}
    />
  </div>
);

export default S;
